<new-flowbanner *ngIf='!isLoading' [showPromo]="true"></new-flowbanner>
<app-newstepper *ngIf='!isLoading' [activeStep]="1"></app-newstepper>

<app-new-loader *ngIf='isLoading'></app-new-loader>

<div class="container" *ngIf="!isLoading && loaded">
    <h3 class="text-center custom-title">
        Elige un plan que se adapte a tus necesidades y presupuesto
    </h3>
    <div class="row d-flex justify-content-center align-items-start g-4">
        <div class="col-12 col-sm-6 col-md-4 mb-4" *ngIf="planArmaTuPlan">
            <div class="d-flex justify-content-center align-self-stretch h-100">
                <div class="card-body">
                    <div class="tag-content"
                        [style.visibility]="planArmaTuPlan.planName === 'Plus' ? 'visible' : 'hidden'">
                        <!-- <span class="badge-new">Nuevo</span> -->
                        <span class="badge-new">Nuevo</span>
                    </div>
                    <h2 class="card-title custom-card-title custom-card-title--build d-flex justify-content-between">
                        {{ planArmaTuPlan.planName }}
                    </h2>

                    <div class="price-container d-flex align-items-center">
                        <p class="price custom-price">${{ getTotal() | number:'1.0-0':'es-CO' }}</p>
                        <p class="price1">/Pago único.</p>
                    </div>

                    <div class="container-description d-flex align-items-center">
                        <img src="./assets/img/Line 1.png" alt="" />
                        <img src="./assets/img/exclamacion.png" alt="Ícono de advertencia" class="img-fluid mb-2" />
                        <p class="description small-text lh-base">
                            El valor varía según el resultado del <br> análisis de tu inquilino y la duración del <br>
                            contrato.
                        </p>
                    </div>

                    <p class="description description--fs16 mb-4">
                        La tarifa es flexible. Ajusta las coberturas a tu medida.
                    </p>
                    <div *ngIf="!planArmaTuPlan.showDetails">
                        <div class="container-separator">
                            <p class="title-principal-coverages">Coberturas principales:</p>
                            <div class="container-principal-coverages">
                                <ul>
                                    <li *ngFor="let coverage of getRequiredCoveragesFromArmaTuPlan()">
                                        {{ coverage.name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="container-separator">
                            <p class="title-option-coverages" *ngIf="getOptionalCoveragesFromArmaTuPlan().length > 0">
                                Coberturas opcionales:</p>
                        </div>
                        <div *ngIf="getOptionalCoveragesFromArmaTuPlan().length > 0">
                            <ul class="list-unstyled">
                                <li *ngFor="let coverage of getOptionalCoveragesFromArmaTuPlan()">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="coverage.selected ?? false"
                                            (change)="onCoverageChange(); coverage.selected = $any($event.target).checked" />
                                        <span class="slider"></span>
                                    </label>
                                    {{ coverage.name }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <button class="btn btn-primary btn-block mb-3"
                        (click)="onSubmit(planArmaTuPlan.planName, planArmaTuPlan)">Comprar</button>

                    <div class="accordion" id="accordionDetalle3">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-heading3">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapse3" aria-expanded="false"
                                    aria-controls="flush-collapse3" (click)="validationEnableDetailSetion(planArmaTuPlan)">
                                    <p class="verDetalle">Ver detalles</p>
                                </button>
                            </h2>
                            <div id="flush-collapse3" class="accordion-collapse collapse"
                                aria-labelledby="flush-heading3" data-bs-parent="#accordionDetalle3">
                                <div class="accordion-body">
                                    <ng-container *ngFor="let coverage of planArmaTuPlan.coverages">
                                        <div class="plan-item mb-3" *ngIf="!coverage.isOptional || coverage.selected">
                                            <div class="d-flex align-items-start">
                                                <img [src]="coverage.isOptional ? ((coverage.selected ?? true) ? './assets/img/cheque1.png' : './assets/img/close-modal.png') : './assets/img/cheque1.png'"
                                                    [alt]="coverage.name" class="mr-2 mb-2"
                                                    [ngClass]="{'grayscale': coverage.isOptional && !(coverage.selected ?? true)}" />
                                                <p
                                                    [ngClass]="{'light-grey': coverage.isOptional && !(coverage.selected ?? true)}">
                                                    <span>{{ coverage.name }}:</span> {{ coverage.detail }}
                                                </p>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <p class="included" *ngIf="getOptionalCoveragesFromArmaTuPlan().length > 0">
                                        Coberturas opcionales:</p>
                                    <ul class="list-unstyled" *ngIf="getOptionalCoveragesFromArmaTuPlan().length > 0">
                                        <li *ngFor="let coverage of getOptionalCoveragesFromArmaTuPlan()">
                                            <label class="switch">
                                                <input type="checkbox" [checked]="coverage.selected ?? false"
                                                    (change)="onCoverageChange(); coverage.selected = $any($event.target).checked" />
                                                <span class="slider"></span>
                                            </label>
                                            {{ coverage.name }}
                                        </li>
                                    </ul>
                                    <p class="condicionado"> Ver el <a
                                            href="https://www.sura.co/documents/d/seguros/clausulado_arriendo_digital"
                                            target="_blank" class="subrayado">condicionado</a> para mayor
                                        información
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4" *ngFor="let plan of planesToShow; let i = index">
            <div class="d-flex justify-content-center h-100">
                <div class="card-body">
                    <div class="tag-content" [style.visibility]="plan.planName === 'Plus' ? 'visible' : 'hidden'">
                        <span class="tag-info">Recomendado</span>
                    </div>
                    <h2 class="card-title custom-card-title custom-card-title--build d-flex justify-content-between">
                        Plan {{ plan.planName }}
                    </h2>

                    <div class="price-container d-flex align-items-center">
                        <p class="price custom-price">${{ plan?.price | number:'1.0-0':'es-CO' }}</p>
                        <p class="price1">/Pago único.</p>
                    </div>

                    <div class="container-description d-flex align-items-center">
                        <img src="./assets/img/Line 1.png" alt="" />
                        <img src="./assets/img/exclamacion.png" alt="Ícono de advertencia" class="img-fluid mr-2" />
                        <p class="description small-text lh-base">
                            El valor varía según el resultado del <br> análisis de tu inquilino y la duración del <br>
                            contrato.
                        </p>
                    </div>

                    <p *ngIf="plan.planName === 'Esencial'" class="description description--fs16 mb-4">
                        Si algo falla, tu arriendo, administración y servicios públicos están protegidos.
                    </p>

                    <p *ngIf="plan.planName === 'Plus'" class="description description--fs16 mb-4">
                        Tienes todo lo del Plan Esencial y además, protege tu hogar con asistencias para reparar daños
                        cuando lo necesites.
                    </p>
                    <div *ngIf="!plan.showDetails">
                        <div class="container-separator">
                            <p class="title-principal-coverages">Coberturas principales:</p>
                            <div class="container-principal-coverages">
                                <ul>
                                    <li *ngFor="let coverage of getRequiredCoveragesFromPlan(plan)">
                                        {{ coverage.name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div *ngIf="getOptionalCoveragesFromPlan(plan).length > 0">
                            <p class="title-option-coverages">Coberturas opcionales:</p>
                            <ul class="list-unstyled">
                                <li *ngFor="let coverage of getOptionalCoveragesFromPlan(plan)">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="coverage.selected ?? true"
                                            (change)="coverage.selected = $any($event.target).checked" />
                                        <span class="slider"></span>
                                    </label>
                                    {{ coverage.name }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="accordion d-block d-md-none" [attr.id]="'accordionDetalleMovil' + i">
                        <div class="accordion-item">
                            <h2 class="accordion-header" [attr.id]="'flush-heading-movil' + i">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#flush-collapse-movil' + i" aria-expanded="false"
                                    [attr.aria-controls]="'flush-collapse-movil' + i" (click)="validationEnableDetailSetion(plan)">
                                    <p class="verDetalle">Ver detalles</p>
                                </button>
                            </h2>
                            <div [attr.id]="'flush-collapse-movil' + i" class="accordion-collapse collapse"
                                [attr.aria-labelledby]="'flush-heading-movil' + i"
                                [attr.data-bs-parent]="'#accordionDetalleMovil' + i">
                                <div class="accordion-body">
                                    <div class="plan-item mb-3" *ngFor="let coverage of plan?.coverages">
                                        <div class="d-flex align-items-start">
                                            <img [src]="coverage.isOptional ? './assets/img/close-modal.png' : './assets/img/cheque1.png'"
                                                [alt]="coverage.name" class="mr-2 mb-2"
                                                [ngClass]="{'grayscale': coverage.isOptional}" />
                                            <p [ngClass]="{'light-grey': coverage.isOptional}">
                                                <span>{{ coverage.name }}:</span> {{ coverage.detail }}
                                            </p>
                                        </div>
                                    </div>
                                    <p class="included">Este plan no incluye:</p>
                                    <div class="plan-item mb-3"
                                        *ngFor="let excludedCoverage of getExcludedCoveragesFromPlan(plan)">
                                        <div class="d-flex align-items-start">
                                            <img src="./assets/img/close-modal.png" [alt]="excludedCoverage.name"
                                                class="mr-2 align-self-start" />
                                            <p class="light-grey mb-0"><span>{{ excludedCoverage.name }}:</span> {{
                                                excludedCoverage.detail }}</p>
                                        </div>
                                    </div>
                                    <p class="condicionado"> Ver el <a
                                            href="https://www.sura.co/documents/d/seguros/clausulado_arriendo_digital"
                                            target="_blank" class="subrayado">condicionado</a> para mayor información
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-primary btn-block mb-3" (click)="onSubmit(plan.planName, plan)"
                        [disabled]="isClicked">Comprar</button>

                    <div class="accordion d-none d-md-block" [attr.id]="'accordionDetalle' + i">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-heading{{i}}">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#flush-collapse' + i" aria-expanded="false"
                                    [attr.aria-controls]="'flush-collapse' + i" (click)="validationEnableDetailSetion(plan)">
                                    <p class="verDetalle">Ver detalles</p>
                                </button>
                            </h2>
                            <div id="flush-collapse{{i}}" class="accordion-collapse collapse"
                                [attr.aria-labelledby]="'flush-heading' + i"
                                [attr.data-bs-parent]="'#accordionDetalle' + i">
                                <div class="accordion-body">
                                    <div class="plan-item mb-3" *ngFor="let coverage of plan?.coverages">
                                        <div class="d-flex align-items-start">
                                            <img [src]="coverage.isOptional ? './assets/img/close-modal.png' : './assets/img/cheque1.png'"
                                                [alt]="coverage.name" class="mr-2 mb-2"
                                                [ngClass]="{'grayscale': coverage.isOptional}" />
                                            <p [ngClass]="{'light-grey': coverage.isOptional}">
                                                <span>{{ coverage.name }}:</span> {{ coverage.detail }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="container-separator">

                                        <div *ngIf="getExcludedCoveragesFromPlan(plan).length > 0">
                                            <p class="not-included">Este plan no incluye:</p>
                                            <ul class="list-unstyled excluded-list">
                                                <li *ngFor="let coverage of getExcludedCoveragesFromPlan(plan)"
                                                    class="d-flex align-items-start">
                                                    <img src="./assets/img/close-modal.png"
                                                        class="mr-2 align-self-start grayscale" [alt]="coverage.name" />
                                                    <p class="light-grey mb-0">{{ coverage.name }}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <p class="condicionado d-none d-lg-block"> Ver el <a
                                            href="https://www.sura.co/documents/d/seguros/clausulado_arriendo_digital"
                                            target="_blank" class="subrayado">condicionado</a> para mayor
                                        información</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<app-help-to-call></app-help-to-call>
<app-footer-app></app-footer-app>